export default function cleanSeoText(html, maxLength = 160) {
  if (!html) return '';
  const text = html
    .replace(/<[^>]*>/g, '')
    .replace(/&nbsp;/gi, ' ')
    .replace(/&amp;/gi, '&')
    .replace(/\s+/g, ' ')
    .trim();

  return text.length > maxLength ? text.slice(0, maxLength - 1) + '…' : text;
}
